import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  All_archive,
  GET_ALL_COMPANIES,
  GET_LEFT_ROOMS,
  GET_USER_BY_PARAMS, GET_TOTAL_FLAGGED_ITEMS,
} from "../../graphql/GraphqlQueries";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { LeftRoomsList } from "./LeftRoomsList";
import StartDiscussionPopup from "../Room/StartDiscussionPopup";
import SettingsOptions from "./SettingsOptions";
import DesktopAppWizard from "./DesktopAppWizard";
import { baseURL } from "../../config/config";
import LeftFilterOptions from "./LeftFilterOptions";
import { useDispatch, useSelector } from "react-redux";
import {
  set_archive_conversations,
  set_conversations,

} from "../../redux/message";
import ComingSoon from "./ComingSoon";
import FlagMsgNotPopup from "./FlagMsgNotPopup"
import ChangePassword from "./ChangePassword";
import { setLeftFilter } from "../../redux/message";
import { Scrollbars } from "react-custom-scrollbars";
import { Tooltip } from "react-tooltip";
import InitialOnboardingImpressions from "../TipsImpressions/InitialOnboardingImpressions";
import LeftBarProject from "./LeftBarProject";
import LeftBarEod from "../EodReport/LeftBarEod";
import LeftBarMaintenance from "../Maintenance/LeftBarMaintenance";
import { isValidConvId } from "../../utils/Common";
import { connectElectronApp, probeElectronApp, connectElectronAppHttp } from "../../utils/electronBridge";
import { labels, iconMap } from "../../utils/Common_module";

import { MUTE_CONVERSATION_MUTATION } from "../../graphql/GraphqlMutation";
import usePolling from "../../hooks/usePolling";
import LeftContainerSkeleton from "../Skeleton/LeftContainerSkeleton";
import LeftMoreOptions from "./LeftMoreOptions";
import { set_Pin_UnPin_user } from '../../redux/adminSlice';
import LeftNotificationOptions from "./LeftNotificationOptions";
import ERPNextLauncher from "../../services/ERPNextLauncher";
import { toast } from 'react-hot-toast';
import LeftBarFlaggedItems from "../Dashboard/partials/flaggedItems/LeftBarFlaggedItems";
import LeftBarFavoritedItems from "../Dashboard/update_partials/myFavoriteFiles/Filesitems/LeftBarFavoritedItems";
import NoFovouriteFilePopup from "./NoFovouriteFilePopup";




const renderScrollThumb = ({ style, ...props }) => (
  <div
    className="track bg-[#0B1F47] rounded-[50px]"
    {...props}
    style={style}
  />
);

const VISIBLE_ROUTES = [
  "/connect/tasks/kanban-view",
  "/connect/tasks/kanban-view/:id",
  "/connect/tasks/list-view",
  "/connect/tasks/notifications",
  "/connect/tasks",
  "/connect/tasks/create-task",
  "/connect/file_hub/tags",
  "/connect/file_hub/files",
  "/connect/file_hub/links",
  "/connect/file_hub",
  "/connect/daily-report",
  "/connect/daily-sales",
  "/connect/maintenance",
];

const matchPath = (path, route) => {
  const pattern = route.replace(/:\w+/g, "[^/]+");
  const regex = new RegExp(`^${pattern}$`);
  return regex.test(path);
};

const ADMIN_ROUTES = new Set([
  "/connect/admin-settings",
  "/connect/account-setting",
  "/connect/otp-management",
  "/connect/otp-history",
  "/connect/team-management",
  "/connect/room-category",
  "/connect/shared-team-tags",
  "/connect/task-management",
  "/connect/marge-company",
  "/connect/rollback-company",
  "/connect/role-manage",
  "/connect/module-management",
  "/connect/venue-management",
  "/connect/business-management",
  "/connect/company-management",
  "/connect/subscription-billing",
  "/connect/subscription-management",
  "/connect/modules-management-dashboard",
  "/connect/business-account-information",
]);

export const LeftSection = ({ me, deferredPrompt, setDeferredPrompt, sidebarOpen = false, setSidebarOpen = () => { } }) => {

  const params = useParams();
  const dispatch = useDispatch();
  const userMe = useSelector((state) => state.message.user);

  const pinuser = useSelector(state => state.admin.pinAccess);

  const [noFlagPopup, setNoFlagPopup] = useState(false);
  const [noFavouritedPopup, setNoFavouritedPopup] = useState(false);
  const [forERP, setForERP] = useState(false);

  const [flaggeditems, setFlaggeditems] = useState([]);
  const { data: FlagCounter } = useQuery(GET_TOTAL_FLAGGED_ITEMS, { fetchPolicy: 'no-cache' });
  useEffect(() => {
    if (FlagCounter?.total_flagged_items?.all_flag_conversation) {
      setFlaggeditems(
        FlagCounter.total_flagged_items
      );
    }
  }, [FlagCounter]);


  const [getUserByParams] = useLazyQuery(GET_USER_BY_PARAMS, { fetchPolicy: "no-cache" });

  const getUserByEmail = async () => {
    try {
      const { data } = await getUserByParams({
        variables: { id: userMe?.id },
      });

      if (data?.user?.status) {
        const userData = data.user.data;
        const access = userData.access;
        // console.log(91, access);
        const hastask = access.includes("task");
        const hasfile = access.includes("file");
        const hassales = access.includes("sales");

        const erp = Array.isArray(userMe?.erpNextRoles) ? userMe.erpNextRoles : [];
        const accessListe = ["dashboard", hastask && "task", hasfile && "file", "sales", "venue sales"].filter(Boolean);
        const accessList = [...accessListe, ...erp];

        const accessList2 = userData.pin_access || [];
        const isSame = accessList.length === accessList2.length && accessList.every(item => accessList2.includes(item));

        dispatch(
          set_Pin_UnPin_user({
            pinAccess: isSame ? accessList2 : accessList
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (userMe?.id) {
      getUserByEmail();
    }
    // [M5] erpNextRoles is an array — join to a string to avoid new-reference re-runs
  }, [userMe?.id, userMe?.erpNext, userMe?.erpNextRoles?.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps
  // [H2+H3] use pinuser directly; labels is a module-level constant, not a dep
  const mergedList = useMemo(() => {
    const totalRequired = 5;
    return (pinuser || []).map((item, index) => ({
      name: item,
      label: labels?.[item] || item,
      pin: index < totalRequired,
    }));
  }, [pinuser]);




  const goRouteoptions = (routeName) => {
    let route = "";

    switch (routeName.label) {
      case "Dashboard":
        route = "dashboard";
        break;

      case "Task":
        route = "tasks/kanban-view";
        break;

      case "FileHub":
        route = "file_hub/tags";
        break;

      case "Calendar":
        setTitleText("Calendar");
        setComingSoon(true);
        return;
      case "Expense":
        setTitleText("Expense");
        setComingSoon(true);
        return;

      case "Workflows":
        setTitleText("Workflows");
        setComingSoon(true);
        return;

      case "Sales":
        route = "daily-report";
        break;

      case "DAR":
        route = "daily-sales";
        break;
      default:
        if (userMe?.erpNext) {
          setMoreOptions("erpNext");
          setMoreOptionsShow(false);
          ERPNextLauncher(userMe, routeName?.label);
          return;
        }
        return;
    }

    if (route) {
      navigate(`/connect/${route}`);
    }
  };
  const {
    conversations,
    archive_conversations,
    countersdata,
    filterLeft,
    workFreelitheme,
  } = useSelector((state) => state.message);

  const unreadConversation_ids = useMemo(
    () =>
      countersdata?.conversations
        ?.filter((v) => v.urreply > 0)
        .map((c) => c.conversation_id) || [],
    [countersdata?.conversations]
  );
  const all_Conversation_ids = useMemo(
    () => countersdata?.all_flag_conversation || [],
    [countersdata?.all_flag_conversation]
  );
  const { data: companiesData } = useQuery(GET_ALL_COMPANIES, {
    variables: { email: me.email },
    fetchPolicy: "no-cache",
  });
  const { loading: LeftRoomsLoading, data: LeftRooms } = useQuery(
    GET_LEFT_ROOMS,
    { variables: { userId: me.id }, fetchPolicy: "no-cache" }
  );

  const [startDiscussion, setStartDiscussion] = useState(false);
  const [searchStr, setSearchStr] = useState("");
  const [filter_status, setFilter_status] = useState("");
  const [moreOptions, setMoreOptions] = useState("");
  const [moreOptionsShow, setMoreOptionsShow] = useState(false);
  const [comingSoon, setComingSoon] = useState(false);
  const [titleText, setTitleText] = useState(false);
  const [archiveRoom, setArchiveRoom] = useState(false);
  const [loader, setLoader] = useState(true);
  const [clearMute] = useMutation(MUTE_CONVERSATION_MUTATION);
  const [showNotify, setShowNotify] = useState(false);
  const [erpNextLoading, setErpNextLoading] = useState(false);
  const [erpNextError, setErpNextError] = useState(null);
  const [moreNotifyShow, setMoreNotifyShow] = useState(false);

  const clearErpNextError = () => {
    setErpNextError(null);
  };

  const handleMuteCheck = async () => {
    const mutedConv = conversations
      ?.filter((f) => f.has_mute?.includes(me?.id))
      ?.map((f) => f.mute)
      ?.flat();

    const parsedMuteData = mutedConv
      ?.map((item) => {
        try {
          // Parse the string as a JSON array
          return JSON.parse(`[${item}]`);
        } catch (error) {
          console.error("Failed to parse mute data:", item, error);
          return null;
        }
      })
      .flat() // Flatten the parsed arrays into a single array
      .filter(Boolean); // Remove any null values

    // console.log("🚀 ~ handleMuteCheck ~ parsedMuteData:", parsedMuteData);

    const currentTimeUnix = Math.floor(Date.now() / 1000);

    for (const mute of parsedMuteData) {
      const { conversation_id, mute_by, mute_unix_end } = mute;

      if (mute_by === me?.id && currentTimeUnix > parseInt(mute_unix_end, 10)) {
        console.log(
          `Conditions matched for conversation: ${conversation_id}. Calling unmute function.`
        );

        const input = {
          conversation_id,
          type: "delete",
        };

        try {
          await clearMute({ variables: { input } });
        } catch (error) {
          console.error("Error clearing mute:", error);
        }
      }
    }
  };
  usePolling(handleMuteCheck, 60000); // Call every 1 minutes

  useEffect(() => {
    if (LeftRooms) {
      dispatch(set_conversations(LeftRooms?.rooms));
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LeftRooms]);

  const clearSearch = useCallback(() => {
    setSearchStr("");
  }, []);

  const [settingOptionsPopup, setSettingOptionsPopup] = useState(false);
  const [filterOptions, setFilterOptions] = useState(false);

  const visible_convs = useMemo(() => {
    if (!conversations) return [];
    return conversations
      .filter(
        (f) =>
          (filter_status === "single" && f.group === "no") ||
          (filter_status === "group" && f.group === "yes") ||
          (filter_status === "createdByMe" && f.created_by === me?.id) ||
          (filter_status === "createdByOther" && f.created_by !== me?.id) ||
          (filter_status === "" && true)
      )
      .filter((r) => r.archive === "no");
  }, [conversations, filter_status, me?.id]);

  const searchLower = searchStr.toLowerCase();
  const searchLowerTrim = searchStr.trim().toLowerCase();
  const matchSearchLower = (f) =>
    f.title.toLowerCase().includes(searchLower) ||
    f.participants_name?.filter((n) => n.toLowerCase().includes(searchLower)).length > 0;
  const matchSearchLowerTrim = (f) =>
    f.title.toLowerCase().includes(searchLowerTrim) ||
    f.participants_name?.filter((n) => n.toLowerCase().includes(searchLowerTrim)).length > 0;

  const threadedRoomsTrim = useMemo(
    () =>
      visible_convs
        .filter((r) => unreadConversation_ids.indexOf(r.conversation_id) > -1)
        .filter(matchSearchLowerTrim),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, unreadConversation_ids, searchLowerTrim]
  );
  const threadedRoomsLoose = useMemo(
    () =>
      visible_convs
        .filter((r) => unreadConversation_ids.indexOf(r.conversation_id) > -1)
        .filter(matchSearchLower),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, unreadConversation_ids, searchLower]
  );
  const flaggedRoomsTrim = useMemo(
    () =>
      visible_convs
        .filter((r) => all_Conversation_ids.indexOf(r.conversation_id) > -1)
        .filter(matchSearchLowerTrim),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, all_Conversation_ids, searchLowerTrim]
  );
  const flaggedRoomsLoose = useMemo(
    () =>
      visible_convs
        .filter((r) => all_Conversation_ids.indexOf(r.conversation_id) > -1)
        .filter(matchSearchLower),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, all_Conversation_ids, searchLower]
  );
  const myRooms = useMemo(
    () =>
      visible_convs
        .filter((r) => r.conversation_id === me?.id)
        .filter(matchSearchLower),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, me?.id, searchLower]
  );
  const pinnedRooms = useMemo(
    () =>
      visible_convs
        .filter((r) => r.pin.indexOf(me?.id) > -1 && r.conversation_id !== me?.id)
        .filter(matchSearchLower),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, me?.id, searchLower]
  );
  const otherRoomsTrim = useMemo(
    () =>
      visible_convs
        .filter((r) => r.pin.indexOf(me?.id) === -1 && r.conversation_id !== me?.id)
        .filter(matchSearchLowerTrim)
        .filter((f) => f.archive === "no"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, me?.id, searchLowerTrim]
  );
  const otherRoomsLoose = useMemo(
    () =>
      visible_convs
        .filter((r) => r.pin.indexOf(me?.id) === -1 && r.conversation_id !== me?.id)
        .filter(matchSearchLower),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visible_convs, me?.id, searchLower]
  );

  const location = useLocation();
  const isAdminSettingsRoute = ADMIN_ROUTES.has(location.pathname);
  const getActiveClass = (_label) => "";

  const navigate = useNavigate();

  const handleGoBack = () => {
    let last_conv = localStorage.getItem("last_active_conv");
    let _id = isValidConvId(last_conv)
      ? last_conv
      : params.conversation_id || userMe.id;
    // navigate("/connect/" + _id);
    setTimeout(() => {
      navigate("/connect/" + _id, { replace: true });
    }, 100);
    // navigate(-1, { replace: true });
  };

  const backToNormal = () => {
    let last_conv = localStorage.getItem("last_active_conv");
    let _id = isValidConvId(last_conv) ? last_conv : params.conversation_id;
    dispatch(setLeftFilter("normal"));
    setArchiveRoom(false);
    navigate(`/connect/${_id}`);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape") {
        setComingSoon(false);
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const [changePasswordPopup, setChangePasswordPopup] = React.useState(false);
  const handleChangePasswordPopup = () => {
    setSettingOptionsPopup(false);
    setChangePasswordPopup(true);
  };
  const handleChangeModulePasswordPopup = () => {
    setSettingOptionsPopup(false);
    setChangePasswordPopup(true);
    setForERP(true);
  };

  useEffect(() => {
    if (filterLeft !== "normal") {
      if (filterLeft === "threaded") {
        let threaded = visible_convs?.filter(
          (r) => unreadConversation_ids.indexOf(r.conversation_id) > -1
        );
        // console.log("🚀 ~ useEffect ~ threaded:", threaded);
        if (threaded.length > 0)
          navigate(
            `/connect/${threaded?.[0]?.conversation_id}/filter/unread_reply`
          );
      } else {

        let flagged = visible_convs?.filter(
          (r) => all_Conversation_ids.indexOf(r.conversation_id) > -1
        );
        if (flagged.length > 0) navigate(`/connect/${flagged?.[0]?.conversation_id}/filter/flag`);
        else {
          const last_conv = localStorage.getItem('last_active_conv');
          navigate(`/connect/${isValidConvId(last_conv) ? last_conv : userMe?.id}/filter/flag`)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterLeft]);

  useEffect(() => {
    if (params.filter_name && params.filter_name === "unread_reply") {
      dispatch(setLeftFilter("threaded"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.filter_name]);


  const [tipsAndTour, setTipsAndTour] = useState(localStorage.getItem('initialTipsAndTour') === 'true');
  const [desktopWizard, setDesktopWizard] = useState(false);

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    if (sp.get('electron_reconnect') === '1' && userMe?.id) {
      connectElectronApp(userMe.id);
      window.history.replaceState({}, '', window.location.pathname);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMe?.id]);

  // Silent auto-connect: when user is logged in, probe for a running Electron app
  // and connect without any user action needed.
  useEffect(() => {
    if (!userMe?.id) return;
    let cancelled = false;
    probeElectronApp().then(running => {
      if (!cancelled && running) connectElectronAppHttp(userMe.id);
    });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMe?.id]);


  const handleStartDiscussion = useCallback(() => {
    setStartDiscussion(true);
    clearSearch();
  }, [clearSearch]);

  const [getArchiveConv] = useLazyQuery(All_archive, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      console.log("🚀 ~ LeftSection ~ data:", data);
      if (data.all_archive.status) {
        dispatch(set_archive_conversations(data.all_archive.data));
        if (data.all_archive.data.length > 0) {
          navigate(`/connect/${data.all_archive?.data[0]?.conversation_id}`);
        }
      }
    },
  });

  const getArchiveConversations = async () => {
    try {
      getArchiveConv();
    } catch (error) {
      console.log("🚀 ~ getArchiveConversations ~ error:", error);
    }
  };

  const handleThreadedMessagesFilter = useCallback(() => {
    dispatch(setLeftFilter("threaded"));
  }, [dispatch]);

  const shouldFilteredDiv = useMemo(
    () => VISIBLE_ROUTES.some(route => matchPath(location.pathname, route)),
    [location.pathname]
  );

  const handleLeftNotification = useCallback(() => {
    setMoreNotifyShow((prev) => !prev);
  }, []);

  useEffect(() => {
    if (me?.role !== "Admin" && me?.login_total === 1 && !me?.multi_company) {
      // Run after component mounts
      const timer = setTimeout(() => {
        setChangePasswordPopup(true);
      }, 300); // small delay ensures UI is ready

      return () => clearTimeout(timer);
    }
  }, [me]);
  // console.log(1234, me?.login_total);

  return (
    <>
      {loader ? (
        <LeftContainerSkeleton />
      ) : (
        <>
          {/* {sidebarOpen && (
            <div
              className="xl:hidden fixed inset-0 bg-black/40 z-[9999] backdrop-blur-[2px] w-[calc(100%-380px)] left-[380px]"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar overlay"
            />
          )} */}
          <div className={`left_container update_version transition-transform duration-300 ease-in-out max-xl:!fixed max-xl:!inset-y-0 max-xl:!left-0 max-xl:!z-50 will-change-transform ${sidebarOpen ? 'max-xl:translate-x-0' : 'max-xl:-translate-x-full'}`}>
            <button
              type="button"
              aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
              aria-expanded={!!sidebarOpen}
              onClick={() => setSidebarOpen(o => !o)}
              className={`xl:hidden absolute top-[19px] ${sidebarOpen ? '-right-[18px]' : '-right-[50px]'} z-[10000] flex items-center justify-center w-9 h-9 rounded-full bg-white shadow-[0_4px_12px_rgba(0,0,0,0.18)] ring-1 ring-black/5 hover:shadow-[0_6px_16px_rgba(0,0,0,0.22)] hover:scale-105 active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0B1F47] transition-all duration-300 ease-out`}
            >
              <span className={`relative block w-5 h-5 ${sidebarOpen ? '' : '-translate-y-[2px]'}`}>
                <span className={`absolute left-0 right-0 mx-auto block h-[2px] w-5 bg-[#0B1F47] rounded transform transition-all duration-300 ease-in-out ${sidebarOpen ? 'top-1/2 -translate-y-1/2 rotate-45' : 'top-[6px] rotate-0'}`} />
                <span className={`absolute left-0 right-0 mx-auto block h-[2px] w-5 bg-[#0B1F47] rounded top-[60%] -translate-y-[60%] transform transition-all duration-300 ease-in-out ${sidebarOpen ? 'opacity-0 scale-x-0' : 'opacity-100 scale-x-100'}`} />
                <span className={`absolute left-0 right-0 mx-auto block h-[2px] w-5 bg-[#0B1F47] rounded transform transition-all duration-300 ease-in-out ${sidebarOpen ? 'top-1/2 -translate-y-1/2 -rotate-45' : 'top-[16px] rotate-0'}`} />
              </span>
            </button>

            <div className="left_top_bar">
              <div className="logoSection">
                <div className="freeli_logo" onClick={() => navigate(0)} />

                <div className="switch_section">
                  {companiesData?.companies?.length > 1 && (
                    <Link to="/connect/switch-account" onClick={() => setSidebarOpen(o => !o)} className="avatar-group-area" title="Switch Account" >
                      <span className="ovel_circle"></span>
                      <div className="avatar bg-[rgb(166,208,104)]" >
                        I
                      </div>
                      <div className="avatar bg-[rgb(255,153,136)]">
                        A
                      </div>
                    </Link>
                  )}

                  {companiesData?.companies?.length > 1 && <Link to="/connect/switch-account" onClick={() => setSidebarOpen(o => !o)} title='Switch account'><div id="companySwitch" className="companySwitch"></div> </Link>}
                  <Tooltip className='z-[9999]' anchorSelect="#companySwitch" content="Switch account"></Tooltip>
                </div>
              </div>

              <div className="filtrSection">
                <div className={"userLogo relative"}>
                  <img src={me.img} alt="user" title="user" />
                  <span className="onLine"></span>
                </div>
                <div className="userInfo_area">
                  <p className="userName_area ellipsis">
                    <span className="font-poppins text-xl font-[400] not-italic tracking-normal text-left text-white leading-[1.6]">{`${me.firstname}`}</span>{" "}
                    <span className="font-poppins text-xl font-[400] not-italic tracking-normal text-left text-white leading-[1.6]">
                      {" "}
                      {`${me.lastname}`}
                    </span>
                  </p>
                  <p className="userName_company">{userMe?.company_name}</p>
                </div>

                <span
                  className="flipNavIcon tooltip5"
                  onClick={() => setSettingOptionsPopup(true)}
                ></span>

              </div>
              {/* Left Notification section  */}
              <div className="nodecoration" id="leftNotificationLink">
                <div className={`leftNotification`} onClick={handleLeftNotification}>
                  <div className="notifications_section flex items-center gap-[10px] pl-[20px]">
                    <div className="leftNotificationIcon"></div>
                    <div className="leftNotificationText">Notifications</div>
                  </div>
                  {!showNotify && countersdata?.notificationcount > 0 && (
                    <div className="notifications_right_section flex items-center gap-[15px] pl-[0px] ">
                      <span className='unreadCounter !left-0 !right-[unset]'>
                        {countersdata.notificationcount > 99 ? (
                          <span className="plus-icon relative">99<span className="">+</span></span>
                        ) : (
                          countersdata.notificationcount
                        )}
                      </span>

                    </div>)}
                </div>
              </div>

              <div className="leftBtn_area new_design">
                <div className="update_version_section">
                  {mergedList?.filter(data => data.pin && data.name)?.map(data => (
                    <React.Fragment key={data.name}>
                      <div className="main_dashboard relative cursor-pointer">
                        {/*
                    {activeRoute(data) && (
                      <div className="pinnedActive">
                        <span className="pinned_icon"></span>
                        <span className="pinnedText">Pinned</span>
                      </div>
                    )}
                     */}
                        <div className={`dashboard iconSection ${getActiveClass(data.label)}`}
                          onClick={() => {
                            const isDashboard = data?.label === "Dashboard";
                            const isOnDashboard = location.pathname === "/connect/dashboard";
                            if (isDashboard && isOnDashboard) {
                              toast.success("Dashboard is already open!", { duration: 4000 });
                            } else {
                              goRouteoptions(data);
                            }
                          }}
                          title={data.label}>
                          <div className={iconMap[data.label] || "filehub_icon"}></div>
                          <p className="left_label">{data.label}</p>
                        </div>
                      </div>

                      {/* FWA (Freeli - Work Assistant) — fixed item, pinned right after Dashboard */}
                      {data.label === "Dashboard" && (
                        <div className="main_dashboard relative cursor-pointer">
                          <div className={`dashboard iconSection ${getActiveClass("FWA")}`}
                            onClick={() => navigate('/connect/mcp')}
                            title="Freeli - Work Assistant">
                            <svg className="all_icon" fill="none" stroke="currentColor" strokeWidth="1.75" viewBox="0 0 24 24" aria-hidden="true">
                              <rect x="6" y="6" width="12" height="12" rx="1.5"></rect>
                              <rect x="9.5" y="9.5" width="5" height="5" rx="0.5"></rect>
                              <path strokeLinecap="round" d="M9 3v3M12 3v3M15 3v3M9 18v3M12 18v3M15 18v3M3 9h3M3 12h3M3 15h3M18 9h3M18 12h3M18 15h3"></path>
                            </svg>
                            <p className="left_label">FWA</p>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))
                  }

                  {(pinuser || []).length > 0 && (
                    <div className="moreOptionArea relative">
                      <div className="moreOptionDiv iconSection">
                        <div className="more_icon_left ml-[3px]" id="moreIcon" onClick={() => setMoreOptionsShow(!moreOptionsShow)}></div>
                      </div>
                      <Tooltip className="z-[9999]" anchorSelect="#moreIcon" content="Click for more options" />
                    </div>
                  )}


                </div>
              </div>

              <div className="left_bottom_section">
                {/* Left search section  */}
                {filterLeft === "normal" ||
                  filterLeft === "threaded" ||
                  filterLeft === "flagged" ||
                  filterLeft === "favouritedFiles" ? (
                  <div className="left_top_bar maiLeftBar !border-b-0">
                    {!isAdminSettingsRoute && (
                      <div className="leftSearchCon">
                        <div
                          className={`leftSearchLeft ${shouldFilteredDiv ? "fullWidth" : ""
                            }`}
                        >
                          <input
                            className="leftSearchInput"
                            type="text"
                            placeholder="Search"
                            value={searchStr}
                            onChange={(e) => setSearchStr(e.target.value)}
                          />
                          {!searchStr && (
                            <span
                              className="leftSearchIcon"
                              data-for="left_tooltip"
                              data-tip="Search"
                            ></span>
                          )}
                          {searchStr && (
                            <span
                              className="leftSearchCloseBtn2 remove !top-[5px]"
                              data-for="left_tooltip"
                              data-tip="Clear Search"
                              onClick={clearSearch}
                              currentItem="false"
                            ></span>
                          )}
                        </div>
                        {!shouldFilteredDiv && (
                          <div
                            id="filetered"
                            className={`leftSearchRight ${filter_status !== "" && "filtered"
                              }`}
                            // onClick={() => setFilterOptions(!filterOptions)}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFilterOptions((prev) => !prev);
                            }}
                          >

                          </div>
                        )}
                      </div>
                    )}
                    <Tooltip
                      className="z-[9999]"
                      anchorSelect="#filetered"
                      content="Filter options"
                    ></Tooltip>
                  </div>
                ) : (
                  ""
                )}

                {location.pathname.indexOf("/connect/tasks") > -1 ? (
                  <LeftBarProject
                    setShowNotify={setShowNotify}
                    countersdata={countersdata}
                    showNotify={showNotify}
                    setSearchStr={setSearchStr}
                    searchStr={searchStr}
                  />
                ) : location.pathname === "/connect/daily-report" ? (
                  <LeftBarEod countersdata={countersdata} setShowNotify={setShowNotify} showNotify={showNotify} setSearchStr={setSearchStr} searchStr={searchStr} />
                ) : location.pathname === "/connect/maintenance" ? (
                  <LeftBarMaintenance
                    setSearchStr={setSearchStr}
                    searchStr={searchStr}
                    countersdata={countersdata}
                  />
                )
                  : location.pathname.indexOf("/connect/favorited_file") > -1 ? (
                    <LeftBarFavoritedItems
                      setSearchStr={setSearchStr}
                      searchStr={searchStr}
                      countersdata={countersdata}
                      user_id={me.id}
                    />
                  )
                    : location.pathname.indexOf("/connect/flagged-items") > -1 ? (
                      <LeftBarFlaggedItems
                        setSearchStr={setSearchStr}
                        searchStr={searchStr}
                        countersdata={countersdata}
                        user_id={me.id}
                      />
                    )
                      : (
                        <div className="room_list_area">
                          {!archiveRoom ? (
                            <>
                              {filterLeft === "normal" && !isAdminSettingsRoute ? (
                                <div className="">
                                  <ul className="border-bottom-light">
                                    <li
                                      className={`conv_list strict !justify-between ${countersdata?.all_flag_conversation.length !== 0
                                        ? "flagPanel"
                                        : " flagPanel_unred"
                                        }`}
                                      onClick={() => {
                                        if (flaggeditems?.all_flag_conversation?.length === 0) {
                                          setNoFlagPopup(true)
                                        }
                                      }}

                                    >
                                      <Link to={flaggeditems?.all_flag_conversation?.length > 0 ? `/connect/flagged-items/${flaggeditems?.all_flag_conversation?.[0]}/messages` : "#"} onClick={() => setSidebarOpen(o => !o)} className="flex justify-between items-center w-full">
                                        Flagged items <span className="flagArrow right-[30px] relative flex items-center gap-[10px]">
                                          {countersdata?.all_flag_conversation.length > 0 && (
                                            <span className='unreadCounter '>
                                              {countersdata.all_flag_conversation.length > 99 ? (
                                                <span className="plus-icon relative">99<span className="">+</span></span>
                                              ) : (
                                                countersdata.all_flag_conversation.length
                                              )}
                                            </span>
                                          )}
                                        </span>
                                      </Link>
                                    </li>
                                    <li
                                      className={`conv_list strict !justify-between FavouriteditemsIcons`}
                                      onClick={() => {
                                        if (flaggeditems?.all_start_file?.length === 0) {
                                          setNoFavouritedPopup(true)
                                        }
                                      }}>
                                      <Link to={flaggeditems?.all_start_file?.length ? `/connect/favorited_file/${flaggeditems?.all_start_file[0]}/files` : "#"} onClick={() => setSidebarOpen(o => !o)} className="flex justify-between items-center w-full">
                                        Favourited items
                                        <span className="flagArrow right-[30px] relative flex items-center gap-[10px]">
                                          {flaggeditems?.all_start_file?.length > 0 && (
                                            <span className='unreadCounter '>
                                              {flaggeditems?.all_start_file?.length > 99 ? "99+" : flaggeditems?.all_start_file?.length ?? 0}
                                            </span>
                                          )}
                                        </span>
                                      </Link>
                                    </li>
                                  </ul>
                                  {countersdata?.total_unread_reply > 0 && (
                                    <div
                                      className="threadMsgBar threadedMessages border-bottom-light"
                                      onClick={handleThreadedMessagesFilter}
                                    >
                                      <div className="thread_button"></div>
                                      <span className="threadMsgText">
                                        Threaded messages
                                      </span>
                                      {countersdata?.total_unread_reply > 0 && (
                                        <span className='unreadCounter !right-[30px]'>
                                          {countersdata.total_unread_reply > 99 ? (
                                            <span className="plus-icon relative">99<span className="">+</span></span>
                                          ) : (
                                            countersdata.total_unread_reply
                                          )}
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            <>
                              <div className="archiveBorderTop"></div>
                              <div
                                onClick={backToNormal}
                                className="!mt-4 !-mb-2 list_container_title bactToAllArchive !pl-[60px]"
                              >
                                <div className="archive_ico !-ml-10 !mr-2"></div>
                                Archives Room
                              </div>
                            </>
                          )}
                          {!archiveRoom ? (
                            <>
                              {filterLeft !== "normal" && !isAdminSettingsRoute && (
                                <div className="left_adminList">
                                  <div
                                    onClick={() => backToNormal()}
                                    className="!mt-4 !-mb-2 borderTop list_container_title bactToAll"
                                  >
                                    <span className="backTomain"></span>
                                    {/* <div className={` ${filterLeft === 'threaded' ? 'filterThreadedMessages' : 'filterFlaggedMessages -mt-1'} `}></div> */}
                                    <div
                                      className={`${filterLeft === "threaded"
                                        ? "filterThreadedMessages"
                                        : filterLeft === "favouritedFiles"
                                          ? "filterFavouritedFiles"
                                          : countersdata?.all_flag_conversation
                                            .length !== 0
                                            ? "filterFlaggedMessages_unred -mt-1"
                                            : "filterFlaggedMessages -mt-1"
                                        }`}
                                    ></div>
                                    {filterLeft === "threaded"
                                      ? "Threaded messages"
                                      : filterLeft === "favouritedFiles"
                                        ? "Favourited items"
                                        : "Flagged items"}
                                  </div>

                                  <div className="borderLine"></div>

                                  <div
                                    className={`group_container adminLists ${showNotify && countersdata?.notificationcount > 0
                                      ? 'h-[calc(100vh-440px)]'
                                      : 'h-[calc(100vh-395px)]'
                                      }`}
                                  >
                                    <ul className="list_container settingsList !h-[100%]">
                                      <Scrollbars
                                        className="custom-scrollbars threadAndFllaged"
                                        renderThumbVertical={renderScrollThumb}
                                        autoHide={false}
                                      >
                                        {filterLeft === "threaded" ? (
                                          <>
                                            <LeftRoomsList
                                              setSearchStr={setSearchStr}
                                              filter_status={filter_status}
                                              setFilter_status={setFilter_status}
                                              user_id={me.id}
                                              rooms={threadedRoomsTrim}
                                              setSidebarOpen={setSidebarOpen}
                                              type="threaded"
                                            />
                                            {threadedRoomsLoose.length === 0 && (
                                              <h2 className="text-center text-sm text-white mt-10">
                                                No matching result found
                                              </h2>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <LeftRoomsList
                                              setSearchStr={setSearchStr}
                                              filter_status={filter_status}
                                              setFilter_status={setFilter_status}
                                              user_id={me.id}
                                              rooms={flaggedRoomsTrim}
                                              setSidebarOpen={setSidebarOpen}
                                              type="flagged"
                                            />
                                            {flaggedRoomsLoose.length === 0 && (
                                              <h2 className="text-center text-sm text-white mt-10">
                                                No flagged messages yet. When you flag something important, it'll show up here.
                                              </h2>
                                            )}
                                          </>
                                        )}
                                      </Scrollbars>
                                      <div
                                        onClick={backToNormal}
                                        className="absolute w-full bottom-[-50px] bactToAllNavigation text-white p-3 z-50 cursor-pointer"
                                      >
                                        <div className="flex gap-1 pb-[1px]">
                                          <div className="bactToAllArchiveBottom"></div>
                                          <div className="text-sm">
                                            Back to navigation
                                          </div>
                                        </div>
                                      </div>
                                    </ul>
                                  </div>
                                </div>
                              )}

                              {isAdminSettingsRoute ? (
                                <div className="left_adminList">
                                  <div
                                    onClick={handleGoBack}
                                    className="!mt-4 !-mb-2 borderTop list_container_title bactToAll"
                                  >
                                    <span className="backTomain"></span>
                                    {/* <MdAdminPanelSettings className=" absolute left-[20px] text-[#ffffff] text-[20px]" /> */}
                                    <span className="settingsIcons"></span>
                                    Settings
                                  </div>

                                  <div className="borderLine"></div>
                                  <div
                                    className={`group_container_admin ${showNotify && countersdata?.notificationcount > 0
                                      ? 'h-[calc(100vh-343px)]'
                                      : 'h-[calc(100vh-297px)]'
                                      }`}
                                  >
                                    <Scrollbars
                                      className="custom-scrollbars"
                                      renderThumbVertical={renderScrollThumb}
                                      autoHide={false}
                                    >
                                      <div className="pb-3">
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/admin-settings"
                                          title="User management"
                                          className={`conv_list ${location.pathname === "/connect/admin-settings" ? "selected" : ""}`}
                                        >
                                          <span className="userManagementIcons"></span>
                                          User management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)} to='/connect/business-account-information' title='Account settings' className={`conv_list ${location.pathname === '/connect/business-account-information' ? 'selected' : ''}`}>
                                          <span className="BusinessManagementIcons"></span>
                                          Account settings
                                        </Link>

                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/team-management"
                                          title="Team management"
                                          className={`conv_list ${location.pathname === "/connect/team-management" ? "selected" : ""}`}
                                        >
                                          <span className="team_managementIcons"></span>
                                          Team management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/room-category"
                                          title="Room categories"
                                          className={`conv_list ${location.pathname === "/connect/room-category" ? "selected" : ""}`}
                                        >
                                          <span className="room_managementIcons"></span>
                                          Room categories
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/venue-management"
                                          title="Venue management"
                                          className={`conv_list ${location.pathname === "/connect/venue-management" ? "selected" : ""}`}
                                        >
                                          <span className="venue-managementIcons"></span>
                                          Venue management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/shared-team-tags"
                                          title="Tag management"
                                          className={`conv_list ${location.pathname === "/connect/shared-team-tags" ? "selected" : ""}`}
                                        >
                                          <span className="tag_managementIcons"></span>
                                          Tag management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/subscription-management"
                                          title="Subscription management"
                                          className={`conv_list ${location.pathname === "/connect/subscription-management" ? "selected" : ""}`}
                                        >
                                          <span className="subscritpion_managementIcons"></span>
                                          Subscription management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/modules-management-dashboard"
                                          title="Module management dashboard"
                                          className={`conv_list ${location.pathname === "/connect/modules-management-dashboard" ? "selected" : ""}`}
                                        >
                                          <span className="settingsIcons top-[4px]"></span>
                                          Module management
                                        </Link>
                                        <Link
                                          onClick={() => setSidebarOpen(o => !o)}
                                          to="/connect/task-management"
                                          title="Task management"
                                          className={`conv_list ${location.pathname === "/connect/task-management" ? "selected" : ""}`}
                                        >
                                          <span className="tasksettingIcon top-[4px]"></span>
                                          Task management
                                        </Link>
                                        {/* <Link to='/connect/business-management' title='Business management' className={`conv_list ${location.pathname === '/connect/business-management' ? 'selected' : ''}`}>Business account</Link> */}
                                      </div>
                                    </Scrollbars>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {filterLeft === "normal" && (
                                    <div
                                      className={`group_container overflow-y-auto ${showNotify && countersdata?.notificationcount > 0
                                        ? 'h-[calc(100vh-420px)]'
                                        : countersdata?.total_unread_reply > 0
                                          ? '!h-[calc(100vh-422px)]'
                                          : 'h-[calc(100vh-360px)]'
                                        }`}
                                    >
                                      <Scrollbars
                                        className="custom-scrollbars"
                                        renderThumbVertical={renderScrollThumb}
                                        autoHide={false}
                                      >
                                        <div className="list_container pinned_list ">
                                          <h3
                                            className="list_container_title pinBar"
                                          // onClick={() => setPinListOpen(!pinListOpen)}
                                          >
                                            Pinned
                                          </h3>
                                          {!LeftRoomsLoading && (
                                            <LeftRoomsList
                                              setSearchStr={setSearchStr}
                                              filter_status={filter_status}
                                              setFilter_status={setFilter_status}
                                              user_id={me.id}
                                              rooms={myRooms}
                                              type="my"
                                              setSidebarOpen={setSidebarOpen}
                                            />
                                          )}
                                          {!LeftRoomsLoading && (
                                            <LeftRoomsList
                                              setSearchStr={setSearchStr}
                                              filter_status={filter_status}
                                              setFilter_status={setFilter_status}
                                              user_id={me.id}
                                              rooms={pinnedRooms}
                                              type="pin"
                                              setSidebarOpen={setSidebarOpen}
                                            />
                                          )}
                                        </div>
                                        <div className="list_container create_conv_list">
                                          <div className="room_label_container">
                                            <h3 className="list_container_title create_conv  w-full">
                                              <span> Rooms</span>
                                              {me.role !== "Guest" && (
                                                <span
                                                  onClick={handleStartDiscussion}
                                                  className="createIcon tooltip5 !absolute !right-0"
                                                  id="startDiscussion"
                                                ></span>
                                              )}
                                            </h3>
                                            {/* <div className={`${roomListCollapse ? "arrow_icon_room" : "arrow_icon_room_up"} `} onClick={() => setRoomListCollapse(!roomListCollapse)}></div> */}

                                          </div>

                                          {!LeftRoomsLoading && (
                                            <LeftRoomsList
                                              setSearchStr={setSearchStr}
                                              filter_status={filter_status}
                                              setFilter_status={setFilter_status}
                                              user_id={me.id}
                                              rooms={otherRoomsTrim}
                                              type="pin"
                                              setSidebarOpen={setSidebarOpen}
                                            />
                                          )}

                                          {otherRoomsLoose.length === 0 && (
                                            <h2 className="text-center text-sm text-white">
                                              No matching result found
                                            </h2>
                                          )}
                                        </div>
                                      </Scrollbars>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div
                                className="group_container archiveLastChild h-[calc(100vh-235px)] overflow-y-auto"
                              >
                                <Scrollbars
                                  className="custom-scrollbars archiveRoomScroll"
                                  renderThumbVertical={renderScrollThumb}
                                  autoHide={false}
                                >
                                  {archive_conversations
                                    ?.filter(
                                      (f) =>
                                        f.title
                                          .toLowerCase()
                                          .includes(searchStr.toLowerCase()) ||
                                        f.participants_name?.filter((n) =>
                                          n
                                            .toLowerCase()
                                            .includes(searchStr.toLowerCase())
                                        ).length > 0
                                    )
                                    .map((v, i) => (
                                      <Link
                                        to={"/connect/" + v.conversation_id}
                                        title="TITLE"
                                        className={`archive_room_con`}
                                        key={
                                          v.conversation_id + "_archive_conversation"
                                        }
                                      >
                                        <ul>
                                          <li
                                            className={`conv_list private ${params.conversation_id ===
                                              v.conversation_id && "selected"
                                              }`}
                                          >
                                            <span className="conv_list_title own">
                                              {v.title}
                                            </span>
                                            <span className="conv_list_Opt"></span>
                                            <span className="conv_list_Opt">
                                              <span className="archive_ico"></span>
                                            </span>
                                          </li>
                                        </ul>
                                      </Link>
                                    ))}
                                </Scrollbars>
                              </div>
                              <div
                                onClick={backToNormal}
                                className="absolute w-full bottom-[100px] archiveRoom bactToAllNavigation text-white p-3 z-50 cursor-pointer"
                              >
                                <div className="flex gap-1 pb-[1px]">
                                  <div className="bactToAllArchiveBottom"></div>
                                  <div className="text-sm">Back to navigation</div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      )}
              </div>
            </div>
          </div>
        </>
      )}
      {startDiscussion && (
        <StartDiscussionPopup setStartDiscussion={setStartDiscussion} />
      )}
      {settingOptionsPopup && (
        <SettingsOptions
          setComingSoon={setComingSoon}
          setTitleText={setTitleText}
          titleText={titleText}
          companiesData={companiesData}
          setArchiveRoom={setArchiveRoom}
          getArchiveConversations={getArchiveConversations}
          setTipsAndTour={setTipsAndTour}
          setSettingOptionsPopup={setSettingOptionsPopup}
          handleChangePasswordPopup={handleChangePasswordPopup}
          handleChangeModulePasswordPopup={handleChangeModulePasswordPopup}
          deferredPrompt={deferredPrompt}
          setDeferredPrompt={setDeferredPrompt}
          setDesktopWizard={setDesktopWizard}
          setSidebarOpen={setSidebarOpen}
        />
      )}
      {filterOptions && (
        <LeftFilterOptions
          setFilterOptions={setFilterOptions}
          filter_status={filter_status}
          setFilter_status={setFilter_status}
          showNotify={showNotify}
        />
      )}
      {moreOptionsShow &&
        <LeftMoreOptions
          setMoreOptions={setMoreOptions}
          moreOptions={moreOptions}
          setMoreOptionsShow={setMoreOptionsShow}
          moreOptionsShow={moreOptionsShow}
          showNotify={showNotify}
          setTitleText={setTitleText}
          setComingSoon={setComingSoon}
          userMe={userMe}
          erpNextLoading={erpNextLoading}
          erpNextError={erpNextError}
          clearErpNextError={clearErpNextError}
          goRouteoptions={goRouteoptions}
        />}
      {moreNotifyShow && (
        <LeftNotificationOptions
          moreNotifyShow={moreNotifyShow}
          setMoreNotifyShow={setMoreNotifyShow}
        />
      )}
      {comingSoon && (
        <ComingSoon titleText={titleText} setComingSoon={setComingSoon} />
      )}
      {noFlagPopup && (
        <FlagMsgNotPopup setNoFlagPopup={setNoFlagPopup} />
      )}
      {noFavouritedPopup && (
        <NoFovouriteFilePopup setNoFovouritePopup={setNoFavouritedPopup} />
      )}

      {changePasswordPopup && (
        <ChangePassword
          onClose={() => setChangePasswordPopup(false)}
          user={me}
          from_admin={false}
          forERP={forERP}
        />
      )}
      {tipsAndTour && (
        <InitialOnboardingImpressions setTipsAndTour={setTipsAndTour} />
      )}
      {desktopWizard && (
        <DesktopAppWizard
          onClose={() => setDesktopWizard(false)}
          userMe={userMe}
        />
      )}
      {/* {tipsAndTour  && (
        <InitialOnboardingImpressions setTipsAndTour={setTipsAndTour} />
    )} */}



      <Tooltip
        className="z-[9999]"
        anchorSelect="#startDiscussion"
        content="Start a discussion"
      ></Tooltip>

    </>
  );
};

